import es from 'date-fns/locale/es';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAuth } from '../../../hooks/useAuth';
import { Html5QrcodeScanner } from "html5-qrcode"
registerLocale('es', es)

function DriverAssignment() {
  const defaultWarningMessage = '¡Error al asignar boleto!.';
  const toast = useRef(null);
  const { user } = useAuth();
  const [vehicles, setVehicles] = useState([]);
  const [orderId, setOrderId] = useState('');
  const [address, setAddress] = useState('');
  const [reference, setReference] = useState('');
  const [selectedVehicle, setSelectedVehicle] = useState(null);  
  const [alertSuccessIsVisible, setAlertSuccessIsVisible] = useState(false);
  const [alertWarningIsVisible, setAlertWarningIsVisible] = useState(false);
  const [alertWarningMessage, setAlertWarningMessage] = useState(defaultWarningMessage);
  const [alertWarningMessage2, setAlertWarningMessage2] = useState('');
  const [isEditinng, setIsEditinng] = useState(true);
  const [isAssigning, setIsAssigning] = useState(false);
  const [isScannerVisible, setIsScannerVisible] = useState(true);


  const onScanSuccess = (decodedText, decodedResult) => {
    // handle the scanned code as you like, for example:
    // onsole.log(`Code matched = ${decodedText}`, decodedResult);
    setOrderId(decodedText);
    showScanner(false);
    // beep();
  }

  const onScanFailure = (error) => {
    // handle scan failure, usually better to ignore and keep scanning.
    // for example:
    console.warn(`Code scan error = ${error}`);
  }

  useEffect(() => {

  }, [isScannerVisible]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    
    getVehicles();


    document.getElementById("scannerContainer").innerHTML = "<div><div id='reader' width='600px'></div></div>";
    let html5QrcodeScanner = new Html5QrcodeScanner(
      "reader",
      { fps: 10, qrbox: { width: 250, height: 250 } },
      /* verbose= */ false);
    html5QrcodeScanner.render(onScanSuccess, onScanFailure);

  }, []);

  const getVehicles = () => {
    fetch(`${process.env.REACT_APP_API_URL}/vehicle/cmb?generic=false`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _vehicles = data.responseObject;
          console.log("vehicles", _vehicles);
          setVehicles(_vehicles);
        }
      });
  };

  const onOrderIdChange = (e) => {
    setOrderId(e.target.value);
  }

  const onAddressChange = (e) => {
    setAddress(e.target.value);
  }

  const onReferenceChange = (e) => {
    setReference(e.target.value);
  }

  const onVehiclesChange = (e) => {
    setSelectedVehicle(e.value);
  }

  const resetData = () => {
    setOrderId('');
    setSelectedVehicle(null);
    setAddress('');
    setReference('');
  };

  const resetAlerts = () => {
    setAlertWarningMessage(defaultWarningMessage);
    setAlertWarningMessage2('');
    setAlertWarningIsVisible(false);
    setAlertSuccessIsVisible(false);
  };

  const onAgainClick = () => {
    resetAlerts();
    setIsEditinng(true);  
    showScanner(true);    
    // window.location.reload();
  };

  // const onTestClick = () => {
  //   var e = document.getElementById('scannerContainer');
  //   if (e.style.display === 'none') {
  //     e.style.display = 'block';
  //     setIsScannerVisible(true);
  //   } else {
  //     e.style.display = 'none';
  //     setIsScannerVisible(false);
  //   }
  // };

  const showScanner = (show) => {
    var e = document.getElementById('scannerContainer');
    if (show) {
      e.style.display = 'block';
      setIsScannerVisible(true);
    } else {
      e.style.display = 'none';
      setIsScannerVisible(false);
    }
  };

  function beep() {
    var snd = new Audio("data:audio/wav;base64,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");
    snd.play();
  }

  const onAssignClick = () => {
    resetAlerts();
    assign(
      user.userId,
      selectedVehicle.vehicleId,
      orderId,
      address, 
      reference            
    );
  }

  const assign = (
    userId,
    vehicleId,
    orderId,
    address,
    reference
  ) => {
    setIsAssigning(true);
    fetch(`${process.env.REACT_APP_API_URL}/order/assignByDriver`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId,
        vehicleId,
        orderId,
        address,
        reference
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        if (data.responseMessage === 'Success') {
          setAlertSuccessIsVisible(true);
          setIsEditinng(false);
          showScanner(false);
          resetData();
        } else {
          setAlertWarningMessage('');
          if (data.responseMessage !== '') setAlertWarningMessage(data.responseMessage);
          // if (data.responseObject !== '') setAlertWarningMessage2(data.responseObject);
          setAlertWarningIsVisible(true);
        }
      } else {
        setAlertWarningMessage('');
        if (data.responseMessage !== '') setAlertWarningMessage(data.responseMessage);
        // if (data.responseObject !== '') setAlertWarningMessage2(data.responseObject);
        setAlertWarningIsVisible(true);
      }
      setIsAssigning(false);
      window.scrollTo(0, 0);
    }, (error) => {
      console.error(error);
      setIsAssigning(false);
    });
  };

  const reportTemplate = (
    <>
      <article>
        <Row>
          <Col>
            <h1 className='app-font'>
              Asignación por conductor
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <Toast ref={toast} />
            <Alert
              key='success'
              variant='success'
              hidden={!alertSuccessIsVisible}>
              ¡Boleto asignado correctamente!
            </Alert>
            <Alert
              key='warning'
              variant='warning'
              hidden={!alertWarningIsVisible}>
              {
                alertWarningMessage !== '' && alertWarningMessage
              }
              {
                alertWarningMessage !== '' && alertWarningMessage2 !== '' &&
                (
                  <>
                    <br />
                  </>
                )
              }
              {
                alertWarningMessage2 !== '' && alertWarningMessage2
              }
            </Alert>
          </Col>
        </Row>
        {/* <Row>
          <Col>
            <Button
              className='p-button-raised app-secondary-button p-button-sm w-100'
              label="test"
              aria-label="test"
              onClick={onTestClick}
            />
          </Col>
        </Row> */}
        {
          ((isEditinng && !isScannerVisible) || (!isEditinng)) &&
          (
            <Row>
              <Col>
                <Button
                  className='p-button-raised app-secondary-button p-button-sm w-100'
                  label={isEditinng ? "Escanear nuevamente" : "Nueva asignación"}
                  aria-label={isEditinng ? "Escanear nuevamente" : "Nueva asignación"}
                  onClick={onAgainClick}
                />
              </Col>
            </Row>
          )
        }        
        <Row>
          <Col>
            <div id="scannerContainer" style={{ display: "block" }}>
            </div>
          </Col>
        </Row>
        {
          isEditinng &&
          (
            <>
              <Row>
                <Col>
                  <div className="flex justify-content-between align-items-center">
                    <span className="p-input-icon-left w-100">
                      <i className="pi pi-qrcode" />
                      <InputText
                        value={orderId}
                        onChange={onOrderIdChange}
                        placeholder="Boleto"
                        className='p-inputtext-sm w-100 mb-2' />
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Dropdown
                    className='p-inputtext-sm w-100 mb-2'
                    value={selectedVehicle}
                    options={vehicles}
                    onChange={onVehiclesChange}
                    optionLabel="description"
                    placeholder="Selecciona el vehículo" />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputText
                    className='p-inputtext-sm w-100 mb-2'
                    value={address}
                    onChange={onAddressChange}
                    placeholder="Destino" />
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputText
                    className='p-inputtext-sm w-100 mb-2'
                    value={reference}
                    onChange={onReferenceChange}
                    placeholder="Origen" />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    className='p-button-raised p-button-sm w-100'
                    label={isAssigning ? "Asignando..." : "Asignar"}
                    aria-label="Asignar"
                    onClick={onAssignClick}
                    disabled={!selectedVehicle || orderId.trim() === '' || address.trim() === '' || reference.trim() === '' || isAssigning} />
                </Col>
              </Row>
            </>
          )             
        }
      </article>
    </>
  );

  return (
    <>
      {reportTemplate}
    </>
  );
}

export default DriverAssignment;